import { gql, TypedDocumentNode } from '@apollo/client';
import { ProtocolDocumentFragment } from '@queries/fragments';
import {
    getProtocolInsightsAccess,
    getProtocolInsightsAccessVariables,
} from '@queries/generated/protocol-insights.generated';

export const ADD_PROTOCOL_DOCUMENT = gql`
    mutation createProtocolDocument($protocolDocument: ProtocolDocumentInput!) {
        createProtocolDocument(protocolDocument: $protocolDocument) {
            ...ProtocolDocumentType
        }
    }
    ${ProtocolDocumentFragment}
`;

export const UPDATE_PROTOCOL_DOCUMENT = gql`
    mutation updateProtocolDocumentStatus($id: Guid!, $status: ProtocolDocumentStatus!) {
        updateProtocolDocumentStatus(id: $id, status: $status) {
            ...ProtocolDocumentType
        }
    }
    ${ProtocolDocumentFragment}
`;

export const CONFIRM_PROTOCOL_DOCUMENT_DECISIONS = gql`
    mutation confirmProtocolDocumentDecisions($riqDocumentId: Guid!, $studyId: ObjectId!) {
        confirmProtocolDocumentDecisions(riqDocumentId: $riqDocumentId, studyId: $studyId) {
            ...ProtocolDocumentType
        }
    }
    ${ProtocolDocumentFragment}
`;

export const ACCEPT_RISK_IQ_ASSOCIATION = gql`
    mutation acceptRiskIQAssociation($criticalVariableRiqId: String!, $riskRiqId: String!, $studyId: ObjectId!) {
        acceptRiskIQAssociation(criticalVariableRiqId: $criticalVariableRiqId, riskRiqId: $riskRiqId, studyId: $studyId)
    }
`;

export const REJECT_RISK_IQ_ASSOCIATION = gql`
    mutation rejectRiskIQAssociation($criticalVariableRiqId: String!, $riskRiqId: String!, $studyId: ObjectId!) {
        rejectRiskIQAssociation(criticalVariableRiqId: $criticalVariableRiqId, riskRiqId: $riskRiqId, studyId: $studyId)
    }
`;

export const ACCEPT_AND_PROMOTE_RISK_IQ_ASSOCIATION = gql`
    mutation acceptAndPromoteRiskIQAssociation($criticalVariableRiqId: String!, $riskRiqId: String!, $studyId: ObjectId!) {
        acceptAndPromoteRiskIQAssociation(criticalVariableRiqId: $criticalVariableRiqId, riskRiqId: $riskRiqId, studyId: $studyId)
    }
`;

export const PENDING_RISK_IQ_ASSOCIATION = gql`
    mutation pendingRiskIQAssociation($criticalVariableRiqId: String!, $riskRiqId: String!, $studyId: ObjectId!) {
        pendingRiskIQAssociation(criticalVariableRiqId: $criticalVariableRiqId, riskRiqId: $riskRiqId, studyId: $studyId)
    }
`;

export const GET_PROTOCOL_INSIGHTS_ACCESS: TypedDocumentNode<
    getProtocolInsightsAccess,
    getProtocolInsightsAccessVariables
> = gql`
    query getProtocolInsightsAccess($studyId: ObjectId!, $app: ProtocolInsightsApp!) {
        protocolInsightsAccess(studyId: $studyId, app: $app)
    }
`;
